export enum CustomerType {
  INDIVIDUAL,
  COMPANY,
}

export const QID_LENGTH = 11;
export const COMPANY_ID_LENGTH = 8;

const now = new Date();

export const MAX_DATE_OF_BIRTH
  = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());

export const MIN_DATE_OF_BIRTH
  = new Date(now.getFullYear() - 75, now.getMonth(), now.getDate());

export const GENDERS = {
  male: { code: 1 },
  female: { code: 2 },
};
